import { React, useEffect } from "react";
import barConfig from "../barConfig";

import {
    Chart as ChartJS,
    PointElement,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
    } from 'chart.js';

import { Bar } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);


function Chart({ resultsForPhase }) {

  return (

    <div>

        <Bar
            data={resultsForPhase}
            options={barConfig}
        />

    </div>

  );
}
export default Chart